import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { useStyles } from './styles';

const CheckboxButtonsGroup = ({
  input,
  title,
  disabledDays,
  isDisabledChange,
  className,
  label,
  popover,
  meta: { touched, error }
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const onChangeHandler = e => {
    if (isDisabledChange) return;

    const item = e.target.value;
    const isChecked = e.target.checked;
    const copyList = { ...input.value };

    copyList[item] = isChecked;

    input.onChange(copyList);
  };

  const isDisabled = (el, value) => {
    if (!disabledDays) return false;

    return !!disabledDays.find(
      item => (!value || isDisabledChange) && item === el
    );
  };

  return (
    <div className={classNames(classes.wrapper, className)}>
      <label className={classes.label}>{t(title)}</label>

      <FormGroup aria-label="position" row>
        {Object.keys(input.value).map((keyName, index) => (
          <FormControlLabel
            classes={{
              root: classes.formControlLabelRoot,
              disabled: classes.disabled
            }}
            key={index}
            value={keyName}
            disabled={isDisabled(keyName, input.value[keyName])}
            control={
              <Checkbox
                checked={input.value[keyName]}
                onChange={onChangeHandler}
                icon={
                  <CheckBoxOutlineBlankIcon className={classes.checkboxIcon} />
                }
                checkedIcon={<CheckBoxIcon className={classes.checkboxIcon} />}
                color="default"
                classes={{
                  root: classes.checkboxRoot,
                  checked: classes.checked,
                  disabled: classes.disabledCheckbox
                }}
              />
            }
            label={
              <div className={classes.checkboxLabel}>
                {label
                  ? typeof label === 'string'
                    ? t(label)
                    : label
                  : t(keyName)}
                {popover && popover}
              </div>
            }
            labelPlacement="end"
          />
        ))}
      </FormGroup>

      {touched && error && <FormHelperText error>{t(error)}</FormHelperText>}
    </div>
  );
};

export default CheckboxButtonsGroup;
